import { Divider, DropDownButton, DropdownItem, IconName } from '@optimus-web/core';
import { LocalizedText, useDialog, useFeatureFlag } from '@mews/framework';
import { FeatureFlag, TextKey } from '@mews-commander/enums';
import { RoleGetResult } from '@mews-commander/data-access';
import { useEnterpriseNavigate } from '@mews-commander/ui';
import { useRoleContext } from '../context';
import { EditRoleDialog } from '../EditRole';
import { DeleteRoleDialog } from '../DeleteRole';
import { usePortfolioSelectors } from '../utils';

export const RolesTableActions = ({
    role,
    onRowDelete,
}: {
    role: RoleGetResult;
    onRowDelete: (id: string) => void;
}) => {
    const { isPortfolio, hasMultiPropertyAccess } = usePortfolioSelectors();
    const editDisabled = !isPortfolio && !role.isLocal;
    const { openRoleDetail } = useRoleContext();
    const [deleteRoleDialogProps, openDeleteRoleDialog] = useDialog();
    const [editRoleDialogProps, toggleEditRoleDialog] = useDialog();

    const newPermissionsEnabled = useFeatureFlag(FeatureFlag.newPermissionsEnabled);
    const navigate = useEnterpriseNavigate();

    return (
        <>
            <DropDownButton icon={IconName.More} size="medium" variant="ghost">
                <DropdownItem
                    key="view"
                    label={<LocalizedText textKey={TextKey.ViewDetails} />}
                    onClick={() => openRoleDetail({ role })}
                />
                {editDisabled ? null : (
                    <DropdownItem
                        key="edit"
                        label={<LocalizedText textKey={TextKey.EditDetails} />}
                        onClick={
                            newPermissionsEnabled
                                ? async () => navigate({ to: 'Roles/$roleId/Edit', params: { roleId: role.id } })
                                : toggleEditRoleDialog
                        }
                    />
                )}
                {isPortfolio && hasMultiPropertyAccess ? (
                    <DropdownItem
                        key="users"
                        label={<LocalizedText textKey={TextKey.RoleEditManageUsers} />}
                        onClick={() => openRoleDetail({ role, users: true })}
                    />
                ) : null}
                {editDisabled ? null : <Divider />}
                {editDisabled || role.userCount ? null : (
                    <DropdownItem
                        key="remove"
                        label={<LocalizedText textKey={TextKey.RoleEditDeleteRole} />}
                        onClick={openDeleteRoleDialog}
                        variant="danger"
                    />
                )}
            </DropDownButton>

            <DeleteRoleDialog role={role} onSuccess={() => onRowDelete(role.id)} {...deleteRoleDialogProps} />
            <EditRoleDialog role={role} {...editRoleDialogProps} />
        </>
    );
};
